import * as React from "react";

function SvgDownArrow(props) {
  return <svg viewBox="0 0 10 6" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M9 1L5.354 4.646a.5.5 0 01-.708 0L1 1" stroke="#CCC" strokeWidth={1.5} fill="none" strokeLinecap="round" /></svg>;
}

export default SvgDownArrow;